import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { RxDatepickerWithInputComponent } from './rx-datepicker-with-input.component';
import { MatInputModule } from '@angular/material/input';
import { IMaskModule } from 'angular-imask';
import { InputMaskDirective } from './mask.directive';
import { RxIconModule } from '@nrwl/rx-icon';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  imports: [
    CommonModule,
    MatDatepickerModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    IMaskModule,
    RxIconModule,
    MatIconModule,
    RxDatepickerWithInputComponent,
    InputMaskDirective,
  ],

  exports: [RxDatepickerWithInputComponent, InputMaskDirective],
})
export class RxDatepickerWithInputModule {}
